import {queryQuizServerGqlApi} from "../../../graphql/quiz/queryQuizServerGqlApi";

import {listQuizByState as listQuizByStateGraphQL} from '../../../graphql/quiz/queries';
import {listQuizzes} from "./listQuizzes";
import { IDataClientService } from '../../../platform/services/data/DataClientService';
import { IAuthService } from '../../../platform/services/auth/AuthService';


export const listQuizByState = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    wsId: string, 
    publication_state?: string, 
    nextToken?: string, 
    limit?: number
): Promise<any> => {

    if (!publication_state) {
        return listQuizzes(dataClientService, authService, wsId, nextToken, limit);
    }

    const quizResponse = await queryQuizServerGqlApi(
        dataClientService,
        authService,
        listQuizByStateGraphQL,
        {
            wsId: wsId,
            publication_state: publication_state,
            limit: limit,
            nextToken: nextToken
        }
    );

    return quizResponse;
}
